module.exports = __webpack_public_path__ + "static/media/logout-icon.925a45e9.svg";